import React from "react";
import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router-dom";
import { Box, Divider, Typography } from "@mui/material";
import DetailBlock from "./DetailBlock";

function OrderDepartureInfo() {
  const { t } = useTranslation();
  const { order, loading } = useOutletContext();

  const isParcel = order.isParcel
    ? `${t("orderTracking.typeDocuments")}`
    : `${t("orderTracking.typeValue")}`;
  const weight = order.isParcel ? "-" : `${order.weight} ${t("orderTracking.weightValue")}`;
  const cod = order.cod ? order.estimatedCost : "0.00";
  const description = order.description === "" ? "-" : order.description;
  const customTag = order.customTag === "" ? "-" : order.customTag;
  const dimensions = order.isParcel ? "-" : `${order.length} x ${order.width} x ${order.height}`;

  return (
    <>
      <Box className={"flex items-center justify-start mx-4"}>
        <Typography className={"p-2 font-bold smMax:pb-0"}>
          {t("orderTracking.departurePart")}
        </Typography>
      </Box>
      <Divider orientation={"horizontal"} flexItem className={"smMax:hidden"} />
      <Box className={"flex flex-col mx-4 p-1.5"}>
        <Box className={"flex items-start justify-stretch w-full smMax:flex-wrap"}>
          <Box className={"my-2 w-1/3 smMax:w-full"}>
            <Typography variant="caption" className={"text-gray-500"}>
              {t("orderTracking.departureAddressPart")}
            </Typography>
            <Typography>
              {order.pickupCity}, <br className={"smMax:hidden"} />
              {order.pickupAddress}
            </Typography>
          </Box>
          <Box className={"my-2 w-1/3 md:hidden smMax:w-full"}>
            <Typography variant="caption" className={"text-gray-500"}>
              {t("orderTracking.deliveryAddressPart")}
            </Typography>
            <Typography>
              {order.deliveryCity}, <br className={"smMax:hidden"} />
              {order.deliveryAddress}
            </Typography>
          </Box>
          <DetailBlock
            text={`${order.estimatedCost} ${t("orderTracking.gel")}`}
            title={t("orderTracking.assessedValue")}
            className={"my-2 w-1/3 smMax:w-1/2"}
          />
          <DetailBlock
            text={`${cod} ${t("orderTracking.gel")}`}
            title={t("ordersTableHeaders.cod")}
            className={"my-2 w-1/3 smMax:w-1/2"}
          />
        </Box>
        <Box className={"flex items-start justify-stretch w-full smMax:flex-wrap"}>
          <Box className={"my-2 w-1/3 smMax:hidden"}>
            <Typography variant="caption" className={"text-gray-500"}>
              {t("orderTracking.deliveryAddressPart")}
            </Typography>
            <Typography>
              {order.deliveryCity},<br />
              {order.deliveryAddress}
            </Typography>
          </Box>
          <DetailBlock
            text={weight}
            title={t("ordersTableHeaders.weight")}
            className={`my-2 w-1/3 smMax:w-1/2 ${order.isParcel ? "smMax:hidden" : ""}`}
          />
          <DetailBlock
            text={dimensions}
            title={t("orderTracking.dimensions")}
            className={`my-2 w-1/3 smMax:w-1/2 ${order.isParcel ? "smMax:hidden" : ""}`}
          />
        </Box>
        <Box className={"flex items-start justify-stretch w-full smMax:flex-wrap"}>
          <Box
            className={`my-2 w-1/3 smMax:w-full ${order.description === "" ? "smMax:hidden" : ""}`}
          >
            <Typography variant="caption" className={"text-gray-500"}>
              {t("ordersTableHeaders.description")}
            </Typography>
            <Typography variant="body2" className={"whitespace-normal truncate"}>
              {description}
            </Typography>
          </Box>
          <Box
            className={`my-2 w-1/3 smMax:w-full ${order.customTag === "" ? "smMax:hidden" : ""}`}
          >
            <Typography variant="caption" className={"text-gray-500"}>
              {t("orderCreation.parcelAttribute")}
            </Typography>
            <Typography variant="body2" className={"whitespace-normal truncate"}>
              {customTag}
            </Typography>
          </Box>
          <DetailBlock
            text={isParcel}
            title={t("orderTracking.type")}
            className={"my-2 w-1/3 smMax:w-1/2"}
          />
        </Box>
      </Box>
    </>
  );
}

export default OrderDepartureInfo;
